<template>
    <div class="bg-white px-3 index" >
        <div class="add_tits" ref="title">
            <el-form class="form-inlines u-f u-ac u-jsb " :inline="true">
                <div>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
                <el-table-column prop="mcn_name" label="主体名称"> </el-table-column>
                <el-table-column prop="mcn_abbreviation" label="机构简称" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="manager_name" label=" 管理员姓名" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="manager_phone" label="管理员手机号"> </el-table-column>
                <!-- <el-table-column prop="examine_text" label="状态">
                    <template slot-scope="{row}">
                        <span v-if="row.examine_text=='不通过'" style="color:red">{{row.examine_text}}</span>
                        <span v-else-if="row.examine_text=='通过'" style="color:green">{{row.examine_text}}</span>
                        <span v-else>{{row.examine_text}}</span>
                    </template>
                </el-table-column> -->
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">详情
                        </el-button>
                         <el-button size="mini"  @click="handleDelete(scope.$index, scope.row)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!--  -->
        <el-dialog title="详情" :visible.sync="dialogs" top="80px" center class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form ref="form" :model="form" label-width="140px" :rules="rule" class="demo-ruleForm">
                    <el-form-item label="用户名：">
                        {{form.user_name}}
                    </el-form-item>
                    <el-form-item label="头像：">
                        <el-image style="width: 100px; height: 100px" v-for="(p,index) in form.user_avatar" :key='index'
                            :src="p.url" :preview-src-list="[p.url]">
                        </el-image>
                    </el-form-item>
                    <el-form-item label="机构简称：">
                        {{form.mcn_abbreviation}}
                    </el-form-item>
                    <el-form-item label="主体名称：">
                        {{form.mcn_name}}
                    </el-form-item>
                    <el-form-item label="机构地址：">
                        {{form.province_code_text}}--{{form.city_code_text}}--{{form.area_code_text}}
                    </el-form-item>
                    <el-form-item label="机构详细地址：">
                        {{form.mcn_address}}
                    </el-form-item>
                    <el-form-item label="社会统一信用码：">
                        {{form.business_license_code}}
                    </el-form-item>
                    <el-form-item label="营业执照：">
                        <el-image style="width: 100px; height: 100px" v-for="(p,index) in form.business_license_pic"
                            :key="index" :src="p.url" :preview-src-list="[p.url]">
                        </el-image>
                    </el-form-item>
                    <el-form-item label="管理员姓名：">
                        {{form.manager_name}}
                    </el-form-item>
                    <el-form-item label="管理员手机号：">
                        {{form.manager_phone}}
                    </el-form-item>

                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogs = false" size="small">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                dialog: false,
                title: '',
                loading: false,
                tableData: [],
                heights: null,

                // 
                eid: '',
                dialogs: false,
                form: {

                },
                rule: {

                },
                count: 0,
                pagesize: 15,
                currentPage: 1,

            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
            that.begin()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                var title = that.$refs.title.offsetHeight
                that.heights = window.innerHeight - title - 200 + 'px'
                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.heights = window.innerHeight - title - 200 + 'px'
                }
            },
            begin() {
                this.currentPage = 1
                this.search()
            },
            search() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/pc/mcn/index", {
                        page: this.currentPage,
                        page_count: this.pagesize
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.count
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            handleEdit(index, row) {
                let that = this
                that.dialogs = true
                that.eid = row.id
                axios
                    .post("/admin/pc/mcn/detail", {
                        id: that.eid
                    }, {
                        token: true
                    })
                    .then(res => {
                        if (res.data.code == 200) {
                            this.form = res.data.data
                        } else {

                        }


                    })
                    .catch(error => {})
            },
            handleDelete(index, row) {
                let that = this
                that.$confirm('此操作将永久删除该机构, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/McnDel", {
                            id: row.id
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                that.search()
                                that.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            } else {
                                that.$message.error(response.data.message);
                            }
                        })
                        .catch(error => {})

                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
        },

    };
</script>